import api from '@modules/store/common/api/index.api';
import type CommonState from '@modules/store/common/types/CommonState.entity';
import type FetchValidationRulesConfig from '@modules/store/common/types/FetchValidationRulesConfig.entity';
import type ValidationRules from '@modules/store/common/types/ValidationRules.entity';
import type ValidationState from '@modules/store/common/types/ValidationState.entity';
import { ActionTree } from 'vuex';

export const actions: ActionTree<ValidationState, CommonState> = {
  fetchValidationRules: async ({ commit }, validationRulesConfig: FetchValidationRulesConfig) => {
    commit('common/staticData/setLoading', true, { root: true });
    commit('setLoading', true);
    new api().fetchValidationRules(validationRulesConfig, (data: ValidationRules) => {
      if (data) {
        commit('setValidationRules', data);
      }
      commit('common/staticData/setLoading', false, { root: true });
      commit('setLoading', false);
    });
  },
};
